import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { HttpClientProvider } from '@services/http/client/http-client-provider';
import TecnologieDesktop from '@components/servizi-soluzioni/desktop/desktop';
import { GetTechnologiesRemoteCall } from '@services/http/remote-calls/snf-api/technologies/get-technologies.http-remote-call';
import { useSiteData } from '../../../context/site-data-context';

export default function Tecnologie() {
  const { idtechnology } = useParams();
  const intl = useIntl();
  const { serviceCategories, technologyCategories } = useSiteData();
  const [payload, setPayload] = useState({
    pages: [],
    mainSectionDescriptions: {},
    mainSectionImageUrl: '',
    mainSectionDarkTheme: false,
    navbarItems: []
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const httpClient = HttpClientProvider.getInstance();
      const technologiesRemoteCall = new GetTechnologiesRemoteCall(idtechnology, intl.locale);
      const data = await httpClient.execute(technologiesRemoteCall);
      if (!cancelled) setPayload(data);
    })();
    return () => {
      cancelled = true;
    };
  }, [idtechnology, intl.locale]);

  return (
    <TecnologieDesktop
      pages={payload.pages}
      mainSectionDescriptions={payload.mainSectionDescriptions}
      mainSectionImageUrl={payload.mainSectionImageUrl}
      mainSectionDarkTheme={payload.mainSectionDarkTheme}
      navbarItems={payload.navbarItems}
      serviceCategories={serviceCategories}
      technologyCategories={technologyCategories}
    />
  );
}
